module.exports = __webpack_public_path__ + "img/5_39.a196957f.png";